"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Answer_1 = require("./Answer");
var Question = /** @class */ (function () {
    function Question() {
    }
    Question.prototype.answeredNo = function () {
        if (this.selectedAnswer != null && this.selectedAnswer instanceof Answer_1.MultipleChoiceAnswer) {
            var answer = this.selectedAnswer;
            return answer.answerText == "No" || answer.answerText == "no";
        }
        return false;
    };
    Question.prototype.answeredYes = function () {
        if (this.selectedAnswer != null && this.selectedAnswer instanceof Answer_1.MultipleChoiceAnswer) {
            var answer = this.selectedAnswer;
            return answer.answerText == "Yes" || answer.answerText == "yes";
        }
        return false;
    };
    return Question;
}());
exports.default = Question;
//# sourceMappingURL=Question.js.map


/** WEBPACK FOOTER **
 ** ./src/models/Question.js
 **/